import { gql } from "@apollo/client";

export const addSettingMutation = gql`
    mutation AddSetting($data: SettingCreateInput!) {
        addSetting(data: $data) {
            id
        }
    }
`;
